import React from 'react';
import { CopyShareComponent, ImageComponent, NameComponent } from './NewProfileComponents';
import { switchIcon } from './Icons';
import { AccountResponse } from '../../api/fetchDocAccounts';
import { getAclViewClassName } from '../../restrictions/utils';
import { SREV2 } from '../../api/pushGenie';

const NewProfile: React.FC<{
    showInviteCode: boolean;
    showInviteLink: boolean;
    message: string;
    inviteCode: string | undefined;
    dName: string;
    imgUrl: string;
    accounts: AccountResponse['data'] | null | undefined;
}> = (props) => {
    const { dName, imgUrl, accounts, inviteCode, message, showInviteCode, showInviteLink } = props;

    return (
        <div className="py-8 px-4 w-full flex flex-col items-end">
            <div className="flex flex-col xl:flex-row xl:space-x-16 xl:space-y-0 space-y-16 xl:items-center w-full">
                <ImageComponent imgUrl={imgUrl} />
                <div className="flex flex-col gap-8">
                    <NameComponent dName={dName} newDesign={true} />
                    <div className="flex flex-col">
                        {showInviteCode && (
                            <p
                                className={`text-neutral-1 text-13 ${getAclViewClassName(
                                    SREV2.INVITE_CODE,
                                )}`}
                            >
                                Invite Code:{' '}
                                <span className="font-700 select-all">{inviteCode}</span>
                            </p>
                        )}
                        <CopyShareComponent
                            showInviteCode={showInviteCode}
                            showInviteLink={showInviteLink}
                            message={message}
                            newDesign={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewProfile;
